export const CREATE_TOOL_DESCRIPTION = `A tool for creating Google Calendar events and meetings.

INPUT example:
"action": "google_calendar_create",
"action_input": "create a new meeting with John Doe tomorrow at 4pm"

OUTPUT:
Output is a confirmation of a created event.
`;

export const VIEW_TOOL_DESCRIPTION = `A tool for retrieving Google Calendar events and meetings.
INPUT examples:
"action": "google_calendar_view",
"action_input": "display meetings for today"

"action": "google_calendar_view",
"action_input": "show events for tomorrow"

"action": "google_calendar_view",
"action_input": "display meetings for tomorrow between 4pm and 8pm"

OUTPUT:
- title, start time, end time, attendees, description (if available)
`;

export const DELETE_TOOL_DESCRIPTION = `A tool for deleting Google Calendar events and meetings.
INPUT example:
"action": "google_calendar_delete",
"action_input": "delete the meeting with John at 3pm"

OUTPUT:
Output is a confirmation of a deleted event.
`;
